<div class="p-4 flex flex-column gap-4" [formGroup]="parentForm">

    <!-- CLASSIFICATION AND NORMATIVE -->
    <div class="surface-card p-4 border-round shadow-1">
        <div class="section-header flex justify-content-between align-items-center">
            <div><i class="pi pi-book"></i> Clasificación y Normativa BPL</div>
        </div>
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-3">
                <label class="block font-medium mb-1">Código Interno</label>
                <input pInputText formControlName="internal_code" placeholder="(Se generará al guardar)" class="w-full text-primary font-bold" [readonly]="true" />
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <label class="block font-medium mb-1">Tipo de Formulación</label>
                <p-select [options]="formulationTypes()" [group]="true" optionGroupLabel="label" optionGroupChildren="items" formControlName="formulationTypeId" optionLabel="label" optionValue="value" placeholder="Seleccione formulación..." class="w-full" appendTo="body" [showClear]="true" [filter]="true">
                    <ng-template let-group pTemplate="group">
                        <div class="flex align-items-center gap-2 border-bottom-1 surface-border pb-1">
                            <i [class]="group.icon" class="text-primary" style="font-size: 1.1rem"></i>
                            <span class="font-bold text-700">{{ group.label }}</span>
                        </div>
                    </ng-template>
                </p-select>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <label class="block font-medium mb-1">Estado Físico</label>
                <p-select [options]="physicalStates" formControlName="physical_state" optionLabel="label" optionValue="value" placeholder="Seleccione estado..." class="w-full" appendTo="body" [showClear]="true"></p-select>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <label class="block font-medium mb-1">Matriz Asociada (LIMS)</label>
                <p-select [options]="matrices()" formControlName="matrixId" optionLabel="label" optionValue="value" placeholder="Seleccione Matriz (opcional)..." class="w-full" appendTo="body" [showClear]="true" [filter]="true"></p-select>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <label class="block font-medium mb-1">Patrocinador (Opcional)</label>
                <p-select [options]="customers()" formControlName="sponsor" optionLabel="name" optionValue="id" placeholder="Seleccione Patrocinador..." class="w-full" appendTo="body" [showClear]="true" [filter]="true" filterBy="code,name">
                    <ng-template let-item pTemplate="item">
                        <strong>{{item.code}}</strong>{{' - ' + (item.name || item.tradename) }}
                    </ng-template>
                </p-select>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <div class="flex align-items-center gap-1 mb-1">
                    <label class="font-medium m-0">Estudio Vinculado (Opcional)</label>
                    <p-button
                        icon="pi pi-info-circle"
                        [rounded]="true"
                        [text]="true"
                        severity="info"
                        pTooltip="¿Cómo se genera el código del estudio?"
                        (onClick)="studyInfoOp.toggle($event)"
                        [style]="{'width': '1.5rem', 'height': '1.5rem', 'padding': '0'}">
                    </p-button>
                </div>
                <div class="flex gap-2">
                    <p-select [options]="studies()" formControlName="studyId" optionLabel="label" optionValue="value" placeholder="Seleccione Estudio..." class="flex-grow-1" appendTo="body" [showClear]="true" [filter]="true"></p-select>
                    <p-button icon="pi pi-plus" [pTooltip]="getStudyButtonTooltip()" tooltipPosition="top" (onClick)="showCreateStudyDialog()" [disabled]="isStudyButtonDisabled()"></p-button>
                </div>
            </div>

            <!-- Popover: Código del Estudio -->
            <p-popover #studyInfoOp [style]="{'max-width': '500px'}">
                <div class="p-4 flex flex-column gap-4">
                    <div class="flex align-items-center gap-3 border-bottom-1 border-100 pb-3">
                        <div style="width:40px;height:40px;border-radius:10px;background:linear-gradient(135deg,#f97316,#c2410c);display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                            <i class="pi pi-book" style="color:white;font-size:1.2rem;"></i>
                        </div>
                        <div>
                            <h3 class="m-0 text-900 font-bold">Código del Estudio Asociado</h3>
                            <p class="m-0 text-500 text-sm">Cómo el sistema construye el código del estudio</p>
                        </div>
                    </div>

                    <p class="m-0 text-600 text-sm line-height-3">Al hacer clic en <b>➕</b>, el sistema genera automáticamente un código de estudio, concatenando:</p>

                    <div class="flex flex-column gap-2">
                        <div class="flex align-items-center gap-2 p-2 bg-purple-50 border-round border-1 border-purple-200">
                            <span class="font-mono text-xs bg-purple-100 px-2 py-1 border-round text-purple-800 font-bold" style="min-width:5rem;text-align:center;">ABREV</span>
                            <span class="text-sm text-600"><b class="text-900">Abreviatura del principio activo</b> (del analito en composición)</span>
                        </div>
                        <div class="flex align-items-center gap-2 p-2 bg-orange-50 border-round border-1 border-orange-200">
                            <span class="font-mono text-xs bg-orange-100 px-2 py-1 border-round text-orange-800 font-bold" style="min-width:5rem;text-align:center;">SUFIJO</span>
                            <span class="text-sm text-600"><b class="text-900">Sufijo BPL o Código</b> del tipo de formulación. Ej: <code>IA</code>, <code>GT</code></span>
                        </div>
                        <div class="flex align-items-center gap-2 p-2 bg-teal-50 border-round border-1 border-teal-200">
                            <span class="font-mono text-xs bg-teal-100 px-2 py-1 border-round text-teal-800 font-bold" style="min-width:5rem;text-align:center;">-SIGLA</span>
                            <span class="text-sm text-600"><b class="text-900">Sigla adicional</b> (opcional, seleccionable al generar). Ej: <code>-RES</code></span>
                        </div>
                        <div class="flex align-items-center gap-2 p-2 bg-green-50 border-round border-1 border-green-200">
                            <span class="font-mono text-xs bg-green-100 px-2 py-1 border-round text-green-800 font-bold" style="min-width:5rem;text-align:center;">-NN</span>
                            <span class="text-sm text-600"><b class="text-900">Número secuencial</b> (2 dígitos). Ej: <code>-01</code></span>
                        </div>
                    </div>

                    <div class="bg-surface-100 p-3 border-round text-center border-1 border-200">
                        <span class="text-xs text-500 block mb-1">Ejemplo de código resultante:</span>
                        <span class="font-mono font-bold text-orange-700 text-lg">GLPIA-RES-01</span>
                    </div>

                    <div class="flex align-items-start gap-2 p-2 bg-blue-50 border-round border-1 border-blue-200 mt-3">
                        <i class="pi pi-info-circle mt-1 text-blue-700 flex-shrink-0 text-sm"></i>
                        <p class="text-xs text-blue-700 m-0 line-height-3">
                            El código del estudio <b>no se regenera automáticamente</b> si se modifica la composición del ítem. En ese caso, actualizá manualmente el estudio desde "Gestión de Inventario → Estudios".
                        </p>
                    </div>
                </div>
            </p-popover>
        </div>
    </div>

    <!-- ACTIVE INGREDIENTS COMPOSITION -->
    <div class="surface-card p-4 border-round shadow-1">
        <div class="section-header flex justify-content-between align-items-center">
            <div><i class="pi pi-th-large"></i> Composición (Principios Activos)</div>
            <p-button label="Agregar Activo" icon="pi pi-plus" size="small" (onClick)="addActiveIngredient()" [disabled]="!allowsMultipleActives && compositionArray.controls.length >= 1" pTooltip="Esta formulación solo admite 1 principio activo" tooltipPosition="top" [tooltipDisabled]="!(!allowsMultipleActives && compositionArray.controls.length >= 1)"></p-button>
        </div>

        <div formArrayName="composition" class="flex flex-column gap-3 mt-3" *ngIf="compositionArray">
            <div *ngIf="compositionArray.controls.length === 0" class="text-center p-4 text-500 surface-100 border-round border-1 border-300 border-dashed">
                No hay principios activos configurados. Presione "Agregar Activo" para comenzar.
            </div>

            <div *ngFor="let act of compositionArray.controls; let i=index" [formGroupName]="i" class="flex flex-wrap md:flex-nowrap align-items-start gap-3 p-3 surface-ground border-round">
                <div class="flex-grow-1">
                    <label class="block font-medium mb-1 text-sm">
                        Determinación / Principio Activo <span class="text-red-500">*</span>
                    </label>
                    <p-autoComplete 
                        formControlName="analite" 
                        [suggestions]="filteredAnalites()" 
                        (completeMethod)="searchAnalites($event)" 
                        field="label" 
                        placeholder="Buscar determinación del catálogo..." 
                        class="w-full" 
                        [style]="{'width':'100%'}" 
                        appendTo="body" 
                        [dropdown]="true"
                        [forceSelection]="true"
                        [ngClass]="{'ng-invalid ng-dirty': act.get('analite')?.invalid && (act.get('analite')?.dirty || act.get('analite')?.touched)}">
                        <ng-template #empty>
                            <div class="p-2 text-sm text-red-600 font-medium flex align-items-center gap-1">
                                <i class="pi pi-times-circle"></i> No se encontraron coincidencias. Debe seleccionar una determinación existente en el catálogo.
                            </div>
                        </ng-template>
                    </p-autoComplete>

                    <!-- Feedback visual de vinculación correcta -->
                    <small class="text-xs text-green-700 font-medium block mt-1" *ngIf="act.get('analite')?.value?.id">
                        <i class="pi pi-check-circle mr-1"></i> Determinación vinculada: <strong>{{ act.get('analite')?.value?.name }}</strong>
                        <span *ngIf="act.get('analite')?.value?.code || act.get('analite')?.value?.analite_code || act.get('analite')?.value?.abbreviation" class="text-500"> [{{ act.get('analite')?.value?.code || act.get('analite')?.value?.analite_code || act.get('analite')?.value?.abbreviation }}]</span>
                    </small>

                    <!-- Feedback visual de error -->
                    <small class="p-error block mt-1" *ngIf="act.get('analite')?.errors?.['invalidAnalite'] && (act.get('analite')?.dirty || act.get('analite')?.touched)">
                        <i class="pi pi-exclamation-triangle mr-1"></i> Debe seleccionar una determinación válida de la lista sugerida (no se permite texto libre).
                    </small>
                    <small class="p-error block mt-1" *ngIf="act.get('analite')?.errors?.['required'] && (act.get('analite')?.dirty || act.get('analite')?.touched)">
                        <i class="pi pi-exclamation-circle mr-1"></i> La determinación es obligatoria.
                    </small>
                </div>
                <div class="w-full md:w-15rem">
                    <label class="block font-medium mb-1 text-sm">Concentración <span class="text-red-500">*</span></label>
                    <p-inputNumber 
                        formControlName="concentration" 
                        [min]="0" 
                        class="w-full" 
                        styleClass="w-full" 
                        [minFractionDigits]="2" 
                        [maxFractionDigits]="4"
                        [ngClass]="{'ng-invalid ng-dirty': act.get('concentration')?.invalid && (act.get('concentration')?.dirty || act.get('concentration')?.touched)}"></p-inputNumber>
                    <small class="p-error block mt-1" *ngIf="act.get('concentration')?.invalid && (act.get('concentration')?.dirty || act.get('concentration')?.touched)">
                        <i class="pi pi-exclamation-circle mr-1"></i> La concentración es obligatoria (mínimo 0).
                    </small>
                </div>
                <div class="w-full md:w-15rem">
                    <label class="block font-medium mb-1 text-sm">Unidad <span class="text-red-500">*</span></label>
                    <p-select 
                        [options]="units()" 
                        formControlName="unit_id" 
                        optionLabel="label" 
                        optionValue="value" 
                        placeholder="Unidad" 
                        class="w-full" 
                        appendTo="body"
                        [ngClass]="{'ng-invalid ng-dirty': act.get('unit_id')?.invalid && (act.get('unit_id')?.dirty || act.get('unit_id')?.touched)}"></p-select>
                    <small class="p-error block mt-1" *ngIf="act.get('unit_id')?.invalid && (act.get('unit_id')?.dirty || act.get('unit_id')?.touched)">
                        <i class="pi pi-exclamation-circle mr-1"></i> La unidad es obligatoria.
                    </small>
                </div>
                <div class="flex-shrink-0">
                    <label class="block font-medium mb-1 text-sm invisible select-none">&nbsp;</label>
                    <p-button icon="pi pi-trash" severity="danger" [outlined]="true" (onClick)="removeActiveIngredient(i)" pTooltip="Eliminar" tooltipPosition="top"></p-button>
                </div>
            </div>
        </div>
    </div>

    <!-- INITIAL RECEPTION DATA -->
    <div class="surface-card p-4 border-round shadow-1">
        <div class="section-header"><i class="pi pi-box"></i> Datos de Recepción</div>
        <div class="grid">
            <div class="col-12 md:col-6">
                <label class="block font-medium mb-1">Cantidad Recibida <span class="text-sm font-normal text-600">(incluye envase)</span></label>
                <p-inputNumber 
                    formControlName="received_quantity" 
                    class="w-full" 
                    styleClass="w-full" 
                    [minFractionDigits]="2" 
                    [maxFractionDigits]="4" 
                    placeholder="Ej: 50.00" 
                    [disabled]="item?.mass_balance_status === 'CLOSED'"
                    (onInput)="onReceivedQuantityInput($event)"></p-inputNumber>
            </div>
            <div class="col-12 md:col-6">
                <label class="block font-medium mb-1">Unidad</label>
                <p-select [options]="units()" formControlName="received_unit_id" optionLabel="label" optionValue="value" placeholder="Seleccione Unidad..." class="w-full" appendTo="body" [filter]="true"></p-select>
            </div>
        </div>
    </div>

    <!-- PARTITIONS / SUBDIVISIONS -->
    <div *ngIf="parentForm.get('id')?.value" class="surface-card p-4 border-round shadow-1">
        <div class="section-header flex justify-content-between align-items-center">
            <div><i class="pi pi-sitemap"></i> Particiones de la Muestra</div>
            <p-button label="Agregar Partición" icon="pi pi-plus" size="small" (onClick)="addPartition()" [disabled]="parentForm.disabled || item?.mass_balance_status === 'CLOSED'" [pTooltip]="item?.mass_balance_status === 'CLOSED' ? 'No se pueden agregar particiones con el balance cerrado' : ''" tooltipPosition="top"></p-button>
        </div>

        <div formArrayName="fractions" class="flex flex-column gap-3 mt-3">

            <p-message
                *ngIf="fractionsOverflow()"
                severity="warn"
                styleClass="w-full"
                [text]="fractionsOverflowMsg()">
            </p-message>
            <div *ngIf="fractionsArray.controls.length === 0" class="text-center p-4 text-500 surface-100 border-round border-1 border-300 border-dashed">
                No hay particiones configuradas para esta muestra. Presione "Agregar Partición" para comenzar.
            </div>

            <div *ngFor="let frac of fractionsArray.controls; let i=index" [formGroupName]="i" class="flex flex-wrap md:flex-nowrap align-items-start gap-3 p-3 surface-ground border-round">
                <!-- Partition Code (Read-only) -->
                <div class="w-full md:w-15rem">
                    <div class="flex align-items-center gap-1 mb-1">
                        <label class="font-medium text-sm m-0">Código de Partición</label>
                        <p-button
                            icon="pi pi-info-circle"
                            [rounded]="true"
                            [text]="true"
                            severity="info"
                            pTooltip="¿Cómo se forma el código?"
                            (onClick)="partitionInfoOp.toggle($event)"
                            [style]="{'width': '1.2rem', 'height': '1.2rem', 'padding': '0'}"
                            *ngIf="i === 0">
                        </p-button>
                    </div>
                    <input pInputText formControlName="code" class="w-full font-bold text-primary" [readonly]="true" />
                </div>

                <!-- Partition Name -->
                <div class="flex-grow-1">
                    <label class="block font-medium mb-1 text-sm">Nombre de la Partición <span class="text-red-500">*</span></label>
                    <input pInputText formControlName="name" placeholder="Ej: Alícuota A, Réplica 1..." class="w-full" [class.p-invalid]="frac.get('name')?.invalid && (frac.get('name')?.dirty || frac.get('name')?.touched)" />
                    <small class="p-error block mt-1" *ngIf="frac.get('name')?.invalid && (frac.get('name')?.dirty || frac.get('name')?.touched)">
                        <i class="pi pi-exclamation-circle mr-1"></i> El nombre de la partición es obligatorio.
                    </small>
                </div>

                <!-- Container Weight (Tare) -->
                <div class="w-full md:w-15rem">
                    <label class="block font-medium mb-1 text-sm">Peso Envase (g) <span class="text-red-500">*</span></label>
                    <p-inputNumber 
                        formControlName="tare" 
                        [min]="0" 
                        class="w-full" 
                        styleClass="w-full" 
                        [minFractionDigits]="2" 
                        [maxFractionDigits]="4" 
                        suffix=" g" 
                        placeholder="0.00" 
                        [disabled]="item?.mass_balance_status === 'CLOSED'"
                        [ngClass]="{'ng-invalid ng-dirty': frac.get('tare')?.invalid && (frac.get('tare')?.dirty || frac.get('tare')?.touched)}"></p-inputNumber>
                    <small class="p-error block mt-1" *ngIf="frac.get('tare')?.invalid && (frac.get('tare')?.dirty || frac.get('tare')?.touched)">
                        <i class="pi pi-exclamation-circle mr-1"></i> El peso de envase es obligatorio.
                    </small>
                </div>

                <!-- Sample Weight (Initial Mass) -->
                <div class="w-full md:w-15rem">
                    <label class="block font-medium mb-1 text-sm">Peso Muestra (g) <span class="text-red-500">*</span></label>
                    <p-inputNumber 
                        formControlName="initial_mass" 
                        [min]="0" 
                        class="w-full" 
                        styleClass="w-full" 
                        [minFractionDigits]="2" 
                        [maxFractionDigits]="4" 
                        suffix=" g" 
                        placeholder="0.00" 
                        [disabled]="item?.mass_balance_status === 'CLOSED'"
                        [ngClass]="{'ng-invalid ng-dirty': frac.get('initial_mass')?.invalid && (frac.get('initial_mass')?.dirty || frac.get('initial_mass')?.touched)}"
                        (onInput)="calculateTotalConsumed()"></p-inputNumber>
                    <small class="p-error block mt-1" *ngIf="frac.get('initial_mass')?.invalid && (frac.get('initial_mass')?.dirty || frac.get('initial_mass')?.touched)">
                        <i class="pi pi-exclamation-circle mr-1"></i> El peso de muestra es obligatorio.
                    </small>
                </div>

                <!-- Actions: Print & Delete -->
                <div class="flex-shrink-0">
                    <label class="block font-medium mb-1 text-sm invisible select-none">&nbsp;</label>
                    <div class="flex gap-2 align-items-center">
                        <p-button icon="pi pi-print" severity="secondary" [outlined]="true" (onClick)="triggerPrintPartition(i)" pTooltip="Imprimir Etiqueta" tooltipPosition="top"></p-button>
                        <p-button icon="pi pi-trash" severity="danger" [outlined]="true" (onClick)="removePartition(i)" *ngIf="!parentForm.disabled && item?.mass_balance_status !== 'CLOSED'" pTooltip="Eliminar Partición" tooltipPosition="top"></p-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Popover: Código de Partición (outside the ngFor, rendered once) -->
    <p-popover #partitionInfoOp [style]="{'max-width': '460px'}">
        <div class="p-4 flex flex-column gap-4">
            <div class="flex align-items-center gap-3 border-bottom-1 border-100 pb-3">
                <div style="width:40px;height:40px;border-radius:10px;background:linear-gradient(135deg,#6366f1,#4338ca);display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                    <i class="pi pi-sitemap" style="color:white;font-size:1.2rem;"></i>
                </div>
                <div>
                    <h3 class="m-0 text-900 font-bold">Código de Partición</h3>
                    <p class="m-0 text-500 text-sm">Cómo se forma el identificador de cada partición</p>
                </div>
            </div>
            <p class="m-0 text-600 text-sm line-height-3">El código se construye <b>automáticamente</b> al agregar cada partición:</p>
            <div class="flex flex-column gap-2">
                <div class="flex align-items-center gap-2 p-2 bg-teal-50 border-round border-1 border-teal-200">
                    <span class="font-mono text-xs bg-teal-100 px-2 py-1 border-round text-teal-800 font-bold" style="min-width:6rem;text-align:center;">COD-ITEM</span>
                    <span class="text-sm text-600"><b class="text-900">Código Interno del Ítem de Ensayo</b>. Ej: <code>2025-GLP-GT-001</code></span>
                </div>
                <div class="flex align-items-center gap-2 p-2 bg-indigo-50 border-round border-1 border-indigo-200">
                    <span class="font-mono text-xs bg-indigo-100 px-2 py-1 border-round text-indigo-800 font-bold" style="min-width:6rem;text-align:center;">N</span>
                    <span class="text-sm text-600"><b class="text-900">Número de orden</b> de la partición. Ej: <code>1</code>, <code>2</code>, <code>3</code>...</span>
                </div>
            </div>
            <div class="bg-surface-100 p-3 border-round text-center border-1 border-200">
                <span class="text-xs text-500 block mb-1">Ejemplo de código de partición:</span>
                <span class="font-mono font-bold text-indigo-700 text-lg">2025-GLP-GT-001-1</span>
            </div>
            <div class="flex align-items-start gap-2 mt-2">
                <i class="pi pi-lock mt-1 text-500 flex-shrink-0 text-sm"></i>
                <p class="text-xs text-500 m-0 line-height-3">
                    El código es de <b>solo lectura</b>. Si se elimina una partición intermedia, las restantes se renumeran automáticamente.
                </p>
            </div>
        </div>
    </p-popover>

    <!-- MASS BALANCE SUMMARY -->
    <div *ngIf="parentForm.get('id')?.value" class="surface-card p-4 border-round shadow-1 mt-2 border-left-3 border-primary">
        <div class="section-header"><i class="pi pi-chart-pie"></i> Balance de Masa Global</div>

        <div class="grid align-items-end mt-3 gap-3 md:gap-0">
            <!-- Read-only computed stats -->
            <div class="col-12 md:col-3 flex flex-column gap-2">
                <span class="text-500 text-sm font-medium">Total Consumido</span>
                <span class="font-bold text-xl text-900">{{ totalConsumed() | number:'1.0-4' }} g</span>
            </div>
            <div class="col-12 md:col-3 flex flex-column gap-2">
                <span class="text-500 text-sm font-medium">Remanente Teórico</span>
                <span class="font-bold text-xl" [ngClass]="theoreticalRemaining() < 0 ? 'text-red-600' : 'text-indigo-600'">
                    <i *ngIf="theoreticalRemaining() < 0" class="pi pi-exclamation-triangle text-red-600 mr-1" pTooltip="Las particiones exceden la cantidad recibida" tooltipPosition="top"></i>
                    {{ theoreticalRemaining() | number:'1.0-4' }} g
                </span>
            </div>

            <!-- Form Controls -->
            <div class="col-12 md:col-3">
                <label class="block font-medium mb-1 text-sm">Remanente Experimental (g)</label>
                <p-inputNumber formControlName="experimental_remaining" class="w-full" styleClass="w-full" [minFractionDigits]="2" [maxFractionDigits]="4" placeholder="0.00" [disabled]="item?.mass_balance_status === 'CLOSED'"></p-inputNumber>
            </div>
            <div class="col-12 md:col-3">
                <label class="block font-medium mb-1 text-sm">Observaciones / Conclusiones</label>
                <textarea pTextarea formControlName="observations" class="w-full" rows="2" placeholder="Añadir conclusiones..." [disabled]="item?.mass_balance_status === 'CLOSED'"></textarea>
            </div>
        </div>
    </div>

    <p-dialog header="Generar Código de Estudio" [(visible)]="createStudyDialogVisible" [modal]="true" [style]="{width: '400px'}">
        <p class="mb-4">Seleccione una sigla opcional para incluir en el código generado. El número incremental se calculará automáticamente.</p>
        <div class="flex flex-column gap-2 mb-4">
            <label class="font-bold">Sigla Adicional (Opcional)</label>
            <p-dropdown [options]="studyTags()" [(ngModel)]="selectedStudyTagId" [ngModelOptions]="{standalone: true}" optionLabel="label" optionValue="value" placeholder="Sin sigla" [showClear]="true" appendTo="body" styleClass="w-full"></p-dropdown>
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Cancelar" icon="pi pi-times" severity="secondary" [text]="true" (onClick)="createStudyDialogVisible = false"></p-button>
            <p-button label="Generar y Vincular" icon="pi pi-check" (onClick)="generateStudy()" [loading]="generatingStudy"></p-button>
        </ng-template>
    </p-dialog>

</div>
